import '../../../index.css';
import '../PageHome/page-home.css';
import SectionMainBanner from '../../@sections/SectionMainBanner/index';
import SectionMainAdvantages from '../../@sections/SectionMainAdvantages/index';
import SectionMainComponents from '../../@sections/SectionMainComponents/index';
import SectionMainServices from '../../@sections/SectionMainServices/index';
import SectionMainOffers from '../../@sections/SectionMainOffers';

const PageHome = () => {
  return (
    <section className="page-home">
      <SectionMainBanner />
      <SectionMainServices />
      <SectionMainComponents />
      <SectionMainAdvantages />
      <SectionMainOffers />
    </section>
  );
};
export default PageHome;
